module.exports = __webpack_public_path__ + "static/media/macbook.14de65f4.png";